<div class="container">
    <div class="caption-0">{{'dashboard.column_group_settings' | stringLiterals}}</div>
    <div class="note-type-area">
        <div class="row-title">{{'dashboard.note_type' | stringLiterals}} <span class="required-field">*</span></div>
        <div class="control">
            <multi-sel-dropdown-filter [dropdownConfig]="dropdownConfig"></multi-sel-dropdown-filter>
        </div>
    </div>
    <div class="options-area">
        <div class="row-title">{{'dashboard.options' | stringLiterals}}</div>
        <div class="control">
            <tam-radio [value]="2" [(ngModel)]="config.display" [disabled]="false" (change)="onChangeOptions($event)">
            </tam-radio>
            <span>{{'dashboard.find_latest_note_by_display_date' | stringLiterals}}</span>
        </div>
        <div class="control">
            <tam-radio [value]="1" [(ngModel)]="config.display" [disabled]="false" (change)="onChangeOptions($event)">
            </tam-radio>
            <span>{{'dashboard.find_latest_note_by_submitted_date' | stringLiterals}}</span>
        </div>
        <div class="control">
            <tam-radio [value]="4" [(ngModel)]="config.display" [disabled]="false" (change)="onChangeOptions($event)">
            </tam-radio>
            <span>{{'dashboard.find_oldest_note_by_display_date' | stringLiterals}}</span>
        </div>
        <div class="control">
            <tam-radio [value]="3" [(ngModel)]="config.display" [disabled]="false" (change)="onChangeOptions($event)">
            </tam-radio>
            <span>{{'dashboard.find_oldest_note_by_submitted_date' | stringLiterals}}</span>
        </div>
        <div class="control">
            <tam-radio [value]="0" [(ngModel)]="config.display" [disabled]="false" (change)="onChangeOptions($event)">
            </tam-radio>
            <span>{{'dashboard.time_series' | stringLiterals}}</span>
        </div>
    </div>
    <div class="filter-area">
        <filter-panel [config]="filterConfig"></filter-panel>
        <div class="control">
            <tam-field-selector [config]="fieldConfig">
            </tam-field-selector>
        </div>
    </div>
</div>